/* ============
 * Vue Upload Component
 * ============
 *
 * Upload component made in China
 *
 * https://lian-yue.github.io/vue-upload-component/
 */

import vueUploadComponent from 'vue-upload-component';

export default vueUploadComponent;
